export default __webpack_public_path__ + "static/media/picto_inspi_2.3c4a3ffe.svg";